module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', {
    staticClass: "mu-tfoot"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdd5f8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/table/tfoot.vue
// module id = 447
// module chunks = 1